import { App, defineAsyncComponent } from 'vue';
import ProductImage from '@/shared/media/ProductImage.vue';
import PDPLink from '@/shared/navigation/PDPLink.vue';
import BlockRender from '@/shared/content/blocks/helpers/BlockRender.vue';
import BlockList from '@/shared/content/blocks/helpers/BlockList.vue';
import CIcon from '@/shared/CIcon.vue';
import { SwiperSlide } from 'swiper/vue';

const asyncSwiper = defineAsyncComponent(() => import(/* webpackChunkName: 'Swiper', webpackPrefetch: true */ '@/shared/Swiper.vue'));

export default function projectComponentRegistration(app: App<Element>) {
    // Global components that we want to use on multiple pages
    app.component(ProductImage.name, ProductImage);
    app.component(PDPLink.name, PDPLink);
    app.component(BlockRender.name, BlockRender);
    app.component(BlockList.name, BlockList);
    app.component(CIcon.name, CIcon);
    app.component('Swiper', asyncSwiper);
    app.component('SwiperSlide', SwiperSlide);
}
